import httpClient from '@utils/httpClient.js';

const getProfileId = () => localStorage.getItem('unilinkProfileId');

export function updateVideosBlockApiCall(options) {
  const { id, title, description, showPlayIcon, textAlign, layout } = options;

  return httpClient.put(`api/profiles/${getProfileId()}/email-marketing/block/videos`, {
    id,
    title,
    description,
    showPlayIcon,
    textAlign,
    layout,
  });
}

export function addVideosItemApiCall(options) {
  const { blockId, image, title, url } = options;

  return httpClient.post(`api/profiles/${getProfileId()}/email-marketing/block/video`, {
    blockId,
    image,
    title,
    url,
  });
}

export function updateVideosItemApiCall(id, options) {
  return httpClient.put(`api/profiles/${getProfileId()}/email-marketing/block/video/${id}`, options);
}

export function deleteVideosItemApiCall(id) {
  return httpClient.delete(`api/profiles/${getProfileId()}/email-marketing/block/video/${id}`);
}
